export const RALTI_PREVIEW_TEST = "https://ralti-test.uoc.edu/preview/";
export const RALTI_PREVIEW_PRE = "https://ralti-pre.uoc.edu/preview/";
export const RALTI_PREVIEW_PRO = "https://ralti.uoc.edu/preview/";